// File: src/pages/TemplatePicker.js

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './TemplatePicker.css'

// Build API_BASE to always include "/api" when hitting your backend
const API_ROOT = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/$/, '')
  : ''
const API_BASE = API_ROOT
  ? `${API_ROOT}/api`
  : '/api'

export default function TemplatePicker() {
  const navigate = useNavigate()
  const [customs, setCustoms] = useState([])

  // Load custom templates from your backend at /api/custom-templates
  const fetchCustoms = () => {
    fetch(`${API_BASE}/custom-templates`)
      .then(res => {
        if (!res.ok) throw new Error(`Load failed (${res.status})`)
        return res.json()
      })
      .then(data =>
        setCustoms(data.map(t => ({
          _id:         t._id,
          name:        t.name,
          description: t.description || '',
          settings:    t.settings,
          fields:      t.fields,
          isCustom:    true
        })))
      )
      .catch(err => console.error('Error loading custom templates', err))
  }
  useEffect(fetchCustoms, [])

  // Duplicate an existing custom
  async function handleDuplicateCustom(id) {
    const r = await fetch(`${API_BASE}/custom-templates/${id}`)
    if (!r.ok) return alert('Could not load template')
    const orig = await r.json()
    const copyName = `${orig.name} Copy`
    const payload = {
      name: copyName,
      key:  copyName.replace(/\s+/g,'').toLowerCase(),
      settings: orig.settings,
      fields:   orig.fields
    }
    const res = await fetch(`${API_BASE}/custom-templates`, {
      method:  'POST',
      headers: { 'Content-Type':'application/json' },
      body:    JSON.stringify(payload)
    })
    if (!res.ok) {
      const txt = await res.text().catch(() => res.statusText)
      return alert(`Duplicate failed: ${txt}`)
    }
    fetchCustoms()
    alert(`"${orig.name}" duplicated as "${copyName}"`)
  }

  return (
    <div className="template-picker">
      <header className="template-picker__header">
        <h1 className="template-picker__title">
          Choose a Cost Card Template
        </h1>
        <p className="template-picker__subtitle">
          Select one to get started—your fields and formulas will load automatically.
        </p>
        <button
          className="template-picker__new-btn"
          onClick={() => navigate('/templates/new')}
        >
          + Create New Custom Template
        </button>
      </header>

      {/* Custom Templates Section */}
      {customs.length > 0 && (
        <section>
          <div className="template-picker__section-title">
            Custom Templates
          </div>
          <div className="template-picker__grid">
            {customs.map(t => (
              <article
                key={t._id}
                className="template-card template-card--custom"
                onClick={() => navigate(`/costcards/create/custom:${t._id}`)}
              >
                <h2 className="template-card__title">{t.name}</h2>
                <p className="template-card__description">{t.description}</p>
                <div className="template-card__actions">
                  <button
                    className="template-card__action"
                    onClick={e => {
                      e.stopPropagation();
                      navigate(`/costcards/create/custom:${t._id}`);
                    }}
                  >Use</button>
                  <button
                    className="template-card__action template-card__action--edit"
                    onClick={e => { e.stopPropagation(); navigate(`/templates/edit/${t._id}`) }}
                  >Customize</button>
                  <button
                    className="template-card__action template-card__action--duplicate"
                    onClick={e => { e.stopPropagation(); handleDuplicateCustom(t._id) }}
                  >Duplicate</button>
                </div>
              </article>
            ))}
          </div>
        </section>
      )}

      {customs.length === 0 && (
        <div className="template-picker__empty">
          <p>No custom templates found. Create your first template to get started!</p>
        </div>
      )}
    </div>
  )
}
